module.exports = __webpack_public_path__ + "static/media/member nalas-04.e8211856.png";